import { AxiosError, AxiosResponse } from 'axios';
import { ErrorResponse } from '@/Domain/api/App/dto/Error.dto';

export class ApiMapper {
  /**
   * Maps Axios Response to response data (response.data)
   */
  static toResponseData<TResponseData = any>(response: AxiosResponse): TResponseData {
    return response.data;
  }

  static toResponseError(error: AxiosError): AxiosError<ErrorResponse> {
    throw error;
  }
}
